module.exports = __webpack_public_path__ + "static/media/SDAM_Logo.c48a3d86.png";